export const MIXIN_IS_UPDATE_PAGE = {
  computed: {
    isUpdatePage () {
      return this.$route.params.id
    },

    isCreatePage () {
      const last = this.$route.path.split('/').at(-1)

      return last === 'create'
    }
  }
}
